/**
 * Die Kacheln der Startseite -- deckungsgleich mit ``TILE_KEYS`` im Server
 * (``modules/reporting/models.py``).
 *
 * **Eigene Datei und nicht neben der Seite.** Sie wird von der Startseite
 * **und** vom Test gebraucht. Eine zweite Liste im Test liefe nach der
 * naechsten Kachel auseinander -- und ein Test, der eine feste Zahl erwartet,
 * wird rot, ohne dass etwas kaputt ist.
 */
export const TILE_KEYS = [
  // F1-50. Vor "offene Vorgaenge", weil sie die dringendere Frage
  // beantwortet: Offen ist vieles, aber bei diesen wartet jemand.
  'awaiting_reply',
  'open_tickets',
  'breached_tickets',
  'created_yesterday',
  'minutes_this_week',
  'by_state_category',
  'volume_trend',
  'sla_compliance',
  'workload',
  // F5-02. Sie steht in der Auswahl wie jede andere -- wer sie nicht sehen
  // darf, bekommt sie ohnehin nicht angezeigt (siehe ``RecentActivityCard``).
  'recent_activity',
] as const;

export type TileKey = (typeof TILE_KEYS)[number];
